class ContentShowcaseCarousel extends HTMLElement {
  constructor() {
    super();

    this.track = this.querySelector('.js-carousel-slider');
    this.slides = this.querySelectorAll('.js-carousel-slide');
    this.navBtns = this.querySelectorAll('.content-showcase-carousel__nav-btn');

    // The outer <section> element whose bg/colour we update per slide
    this.section = document.getElementById('section-' + this.dataset.sectionId);

    if (!this.track || !this.slides.length) return;

    // Numbered nav button clicks
    this.navBtns.forEach((btn) => {
      btn.addEventListener('click', () => {
        this.goToSlide(parseInt(btn.dataset.slide, 10));
      });
    });

    // Sync on scroll (covers swipe / programmatic scrollTo)
    this.track.addEventListener('scroll', () => this.sync(), { passive: true });

    // Re-sync after any layout resize (orientation change, etc.)
    if ('ResizeObserver' in window) {
      new ResizeObserver(() => this.sync()).observe(this.track);
    }

    // Sync immediately so initial state is consistent with slide 0
    this.sync();
  }

  goToSlide(index) {
    // Each slide is 100% of the track's client width — exact, no offsetParent issues
    this.track.scrollTo({
      left: index * this.track.clientWidth,
      behavior: 'smooth',
    });
  }

  sync() {
    const slideWidth = this.track.clientWidth;
    if (!slideWidth) return;

    const current = Math.round(this.track.scrollLeft / slideWidth);
    const currentSlide = this.slides[current];

    // ── Update numbered nav buttons ───────────────────────────
    this.navBtns.forEach((btn, i) => {
      const active = i === current;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-selected', String(active));
    });

    // ── Transition section background & text colour ───────────
    // The CSS transition on .content-showcase-carousel-section
    // animates this smoothly between slides.
    if (this.section && currentSlide) {
      const bg = currentSlide.dataset.bg;
      const color = currentSlide.dataset.color;
      if (bg) this.section.style.backgroundColor = bg;
      if (color) this.section.style.color = color;
    }
  }
}

customElements.define('content-showcase-carousel', ContentShowcaseCarousel);
